import React, { useEffect, useState } from "react";
import Cartproduct from "./Cartproduct";
import { deleteData, getData, postData, putData } from "../global/Globalapi";
import { useNavigate } from "react-router-dom";
import Razor from "../Razorpay/Razor";
import { toast } from "react-toastify";
import { handlePayment } from "../buying/Buy";
import {
  fetchCartItems,
  handleDecrease,
  handleIncrease,
  handleRemove,
} from "./CartFunctions";
import { IoArrowBackOutline } from "react-icons/io5";
const Cart = () => {
  const [cart, setCart] = useState([]);
  const [refresh, setRefresh] = useState(false);

  const userstring = localStorage.getItem("user");
  const user = userstring ? JSON.parse(userstring) : null;
  console.log("userdetails", { user });
  console.log("cart Details", cart);
  const userId = user?.user_id;
  const userdetails = {
    name: user.name,
    email: user.email,
    phone: user.mobile,
  };
  const navigate = useNavigate();

  useEffect(() => {
    fetchCartItems(userId, setCart);
  }, [refresh]);
  const goToShopping = () => {
    navigate(-1);
  };
  //  const fetchCartItems = async () => {
  //   try {
  //     setCart([]);
  //     console.log(userId)
  //     const res = await getData(`/cart/${userId}`);
  //     console.log(res);
  //     setCart(res.data);
  //   } catch (err) {
  //     console.error("Error fetching cart:", err);
  //   }
  // };
  const handleRefund = async () => {
    // if (!paymentId) {
    //   toast.error("Missing payment ID");
    //   return;
    // }

    try {
      const res = await postData("/refund", {
        payment_id: "pay_QozCQRVC1XWvwY",
        amount: 10000,
      });

      if (res.success) {
        toast.success("Refund initiated successfully");
        console.log("Refund response:", res);
      } else {
        toast.error("Refund failed");
      }
    } catch (err) {
      toast.error("Refund error");
      console.error("Refund request failed:", err);
    }
  };
  // const handleRemove = async (id) => {
  //   console.log('deleted id',id)
  //   try {
  //     await deleteData(`/cart/${userId}/${id}`);
  //     // Remove from frontend state too
  //     setCart((prevCart) =>
  //       prevCart.filter((item) => item.id !== id)
  //     );
  //     setRefresh(prev => !prev);
  //   } catch (err) {
  //     console.error("Error removing cart item:", err);
  //   }
  // };
  //     const handleIncrease = async (id) => {
  //   try {
  //     await putData(`/cart/increase/${id}`); // PUT request
  //     setRefresh(prev => !prev); // Refresh cart
  //   } catch (err) {
  //     console.error("Error increasing quantity:", err);
  //   }
  // };

  // const handleDecrease = async (id, quantity) => {
  //   if (quantity <= 1) {
  //     toast.warning("Quantity cannot go below 1");
  //     return;
  //   }

  //   try {
  //     await putData(`/cart/decrease/${id}`); // PUT request
  //     setRefresh(prev => !prev); // Refresh cart
  //   } catch (err) {
  //     console.error("Error decreasing quantity:", err);
  //   }
  // };
  const totalAmount = cart.reduce(
    (total, item) => total + parseFloat(item.amount),
    0,
  );
  //  const handlePayment = async (amount) => {
  //          const cartIds = Array.isArray(cart)
  //         ? cart.map(item => item.id).join(",")
  //          : "";
  //         const isScriptLoaded = await Razor();
  //         if (!isScriptLoaded) {
  //           alert("Razorpay SDK failed to load. Are you online?");
  //           return;
  //         }

  //         // Create order on server
  //         const orderRes = await postData("/create-order", { amount,cart });
  //         console.log("function", amount);
  //         console.log('razorpay response',orderRes);
  //         const options = {
  //           key: process.env.REACT_APP_RAZORPAY_KEY_ID, // Must be set in .env
  //           amount:amount*100,
  //           currency: "INR",
  //           name: "Bolt And Brook",
  //           description: "Product Purchase",
  //           order_id: orderRes.id,
  //           handler:async function (response) {
  //             toast.success("Payment successful!", { autoClose: 50000 });
  //             console.log("Payment Details:", response);
  //             console.log("order details",orderRes);
  //             console.log('paymentid',response.razorpay_payment_id)
  //             const paymentdata=  await postData("/save-payment",
  //                 { payment_id: response.razorpay_payment_id,
  //                 },
  //                 {
  //                  headers: {
  //                  "Content-Type": "application/json"
  //                  }
  //                  } )

  //               console.log("userid",userId);
  //               console.log("atlast order",orderRes);
  //               console.log("atlast payment response",paymentdata);
  //             // Optional: Send to backend for verification
  //           },
  //           prefill: {
  //             name: userdetails?.name ,
  //             email: userdetails?.email ,
  //             contact: userdetails?.phone ,
  //             cart:cartIds,
  //           },
  //           notes: {
  //             address:"123muthukrishnapuram2nd street",
  //             "greetings":"thanks for shopping",
  //           },

  //           theme: {
  //             color: "#ff0000",
  //           },

  //         };

  //         const rzp = new window.Razorpay(options);
  //         rzp.open();
  //       };
  // const buynow = () => {
  //   navigate("/checkout");
  // };

  const buynow = () => {
  navigate("/checkout", {
   state: { cartItems: cart }
  });
};
  // Add this API call in ProductView or create a separate function
  const fetchBatchStock = async (productId) => {
    try {
      const res = await getData(`/product/batch-stock/${productId}`);
      return res.data;
    } catch (error) {
      console.error("Error fetching batch stock:", error);
      return { totalStock: 0 };
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-6 px-4 sm:px-6 lg:px-8 relative">
      <h1 className="text-2xl font-bold mb-6 text-gray-800">Your Cart</h1>
      <>
        <button
          onClick={goToShopping}
          className="mb-4 bg-[#c97c5d] hover:bg-orange-600 text-white font-semibold px-4 py-2 rounded-lg"
        >
          <IoArrowBackOutline className="text-2xl" />
        </button>
      </>

      {cart.length > 0 ? (
        <>
          {/* Cart Items Grid */}
          {/* <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 w-full pb-32">
            {cart.map((product, index) => (
              <Cartproduct key={index} product={product} handleRemove={() => handleRemove(product.id,setCart,userId,setRefresh)}
                 handleIncrease={() => handleIncrease(product.id,setRefresh)}
                 handleDecrease={() => handleDecrease(product.id, product.quantity,setRefresh)}
              />
            ))}
          </div> */}
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 w-full pb-32">
            {cart.map((item) => (
              <div
                key={item.id}
                className="bg-white border rounded-xl shadow-sm hover:shadow-md transition p-4 flex flex-col"
              >
                {/* Product Image */}
                <div className="h-40 bg-gray-100 rounded-lg overflow-hidden">
                  <img
                    src={item.image_url}
                    alt={item.product_name}
                    className="w-full h-full object-cover"
                  />
                </div>

                {/* Product Info */}
                <div className="mt-3 flex-1">
                  <h3 className="font-semibold text-gray-800 truncate">
                    {item.product_name}
                  </h3>
                  <p className="text-[#c97c5d] font-bold text-lg mt-1">
                    ₹{item.amount}
                  </p>
                </div>

                {/* Quantity Controls */}

                <div className="flex items-center justify-center gap-4">
                  <button
                    onClick={() =>
                      handleDecrease(item.id, item.quantity, setRefresh)
                    }
                    className="w-9 h-9 flex items-center justify-center
               rounded-full bg-[#c97c5d] text-white text-xl font-bold
               hover:bg-orange-600  active:scale-95 transition"
                  >
                    −
                  </button>

                  <span className="text-lg font-semibold min-w-[24px] text-center">
                    {item.quantity}
                  </span>

                  <button
                    onClick={() => handleIncrease(item.id, setCart, setRefresh)}
                    className="w-9 h-9 flex items-center justify-center
               rounded-full bg-[#c97c5d] text-white text-xl font-bold
               hover:bg-orange-600  active:scale-95 transition"
                  >
                    +
                  </button>
                  <button
                    onClick={() =>
                      handleRemove(item.id, setCart, userId, setRefresh)
                    }
                    // className="text-sm bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded-lg transition"
                    className="text-xs bg-red-500 hover:bg-red-600 text-white px-2 py-1 rounded-md transition"
                  >
                    Remove
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* Footer Section */}
          <div className="fixed bottom-0 left-0 w-full bg-white shadow-md p-4 border-t flex justify-between items-center">
            <h2 className="text-xl font-semibold text-gray-800">
              Total: ₹{totalAmount.toFixed(2)}
            </h2>
            <button
              className="bg-yellow-400 hover:bg-yellow-700 text-black font-semibold px-6 py-2 rounded-lg"
              onClick={buynow}
            >
              Buy Now
            </button>
            {/* <button
              className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-2 rounded-lg"
              onClick={handleRefund}
            >
              return 
            </button> */}
          </div>
        </>
      ) : (
        <p className="text-gray-500 text-center">Your cart is empty.</p>
      )}
    </div>
  );
};

export default Cart;
